import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-52053274"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-container" }
const _hoisted_2 = {
  class: "contact-contents",
  ref: "scrollContainerRef"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = {
  class: "contact-list",
  role: "list"
}
const _hoisted_5 = { class: "sub-title" }
const _hoisted_6 = { class: "contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], { title: "고객지원" }),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.sortedContactsEntries, ([campusName, contacts], index) => {
            return (_openBlock(), _createElementBlock("section", {
              class: "row-wrapper",
              key: index
            }, [
              _createElementVNode("h2", _hoisted_3, _toDisplayString(campusName), 1 /* TEXT */),
              _createElementVNode("ul", _hoisted_4, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(contacts, (contact, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    class: "contact-item",
                    key: index,
                    role: "listitem"
                  }, [
                    _createElementVNode("h3", _hoisted_5, _toDisplayString(contact.name), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_6, [
                      _createElementVNode("span", null, _toDisplayString($setup.useFormattingPhoneNumber(contact.officeNumber)), 1 /* TEXT */),
                      _createElementVNode("span", null, "(문의가능시간 : " + _toDisplayString($setup.getAvailableContactTime(contact)) + ")", 1 /* TEXT */)
                    ])
                  ]))
                }), 128 /* KEYED_FRAGMENT */))
              ])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ], 512 /* NEED_PATCH */)
      ]),
      ($setup.scrollContainerRef)
        ? (_openBlock(), _createBlock($setup["ScrollTopControl"], {
            key: 0,
            container: $setup.scrollContainerRef
          }, null, 8 /* PROPS */, ["container"]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}